import isEmpty from 'lodash/isEmpty';
import {
  RouteType,
  getChildStructureDetails,
  ProjectSynthesisPartner,
  STRUCTURE_DETAILS_ALL_BB,
  getHighlightedChildParameters,
} from '@Pages/RetroSynthesis/constants';

export const mapProjectIdsForLiveUpdates = (projects = []) =>
  projects.reduce(
    (memo, { id, publishedParameters, predictedParameters, childProjects }) => {
      // eslint-disable-next-line no-unused-expressions
      !isEmpty(publishedParameters) && memo[RouteType.PUBLISHED].push(id);
      // eslint-disable-next-line no-unused-expressions
      !isEmpty(predictedParameters) && memo[RouteType.PREDICTED].push(id);
      if (childProjects) {
        const childIds = childProjects.map((child) => child.id);
        memo[RouteType.PREDICTED].push(...childIds);
      }
      return memo;
    },
    {
      [RouteType.PUBLISHED]: [],
      [RouteType.PREDICTED]: [],
    }
  );

export const collectChildIds = (projects = []) => {
  const allChildIds = [];
  const allParentIds = [];
  projects.forEach((project) => {
    const { childIds } = project;
    if (childIds) {
      allChildIds.push(...childIds);
      allParentIds.push(project.id);
    }
  });
  return { allChildIds, allParentIds };
};

/* eslint-disable no-param-reassign */
export const populateChildProjects = (projects = [], childProjects = []) => {
  projects.forEach((project) => {
    const { childIds, childProjects: existingChildProjects } = project;
    if (childIds) {
      const children = childProjects.filter((ch) => childIds.includes(ch.id)).sort((ch1, ch2) => ch2.id - ch1.id);
      children.forEach((ch) => {
        const params = ch.predictedParameters;

        ch.parentId = project.id;
        if (
          (params.partner === ProjectSynthesisPartner.IKTOS && params.maxNoOfSteps === 1) ||
          (params.partner === ProjectSynthesisPartner.PAI && !params.fullSynthesisPlan)
        ) {
          // second step
          ch.step = 2;
          ch.structureDetails = getChildStructureDetails(ch.predictedParameters.partner, 2);
        } else {
          // first step
          ch.step = 1;
          ch.structureDetails = getChildStructureDetails(ch.predictedParameters.partner, 1);
        }
        params.highlightedParams = getHighlightedChildParameters(params.partner, ch.step);

        if (
          params.usedBuildingBlocks &&
          params.usedBuildingBlocks.length &&
          params.usedBuildingBlocks.length > (project?.predictedParameters?.usedBuildingBlocks || []).length
        ) {
          ch.structureDetails.push(STRUCTURE_DETAILS_ALL_BB);
          params.highlightedParams.push('usedBuildingBlocks');
        }
      });

      project.childProjects = [...children, ...(existingChildProjects || [])];
    }
  });
};

export function getParentAndChildProjectsByIds(projects, ids) {
  return projects.reduce((acc, project) => {
    if (ids.includes(project.id)) {
      acc.push(project);
    }
    if (project.childProjects) {
      project.childProjects.forEach((child) => {
        if (ids.includes(child.id)) {
          acc.push(child);
        }
      });
    }
    return acc;
  }, []);
}
